import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Verificarea istoricului unui CI (`GET /api/v2/cmdb/ci/{id}/history/verify`,
 * `App\Cmdb\History\HistoryIntegrity`): lanturile de hash-uri recalculate.
 */

/** De ce s-a rupt un lant - vezi `ChainVerifier`. */
export type ChainBreak = 'missing' | 'deleted' | 'link' | 'hash' | 'head'

export interface HistoryChain {
  label: string
  key: string
  ok: boolean
  checked: number
  legacy: number
  archived: number
  suppressed: number
  head_seq: number
  broken: { seq: number; id: number; reason: ChainBreak } | null
}

export interface HistoryIntegrity {
  ready: boolean
  ok: boolean | null
  protected?: boolean
  triggers?: { installed: number; expected: number; missing: string[] }
  chains: HistoryChain[]
  checked_at: string
}

export function ciHistoryVerifyQuery(id: number, enabled: boolean) {
  return queryOptions({
    queryKey: ['cmdb', 'ci', id, 'history', 'verify'],
    queryFn: () => apiGet<HistoryIntegrity>(`/cmdb/ci/${id}/history/verify`),
    enabled,
    staleTime: 0,
  })
}
